<template>

    <body style="direction: rtl; text-align: right;">
        <Header pageTitle="المستقلين" />
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <!-- محتوى الصفحة -->
        <div v-else>
            <section class="container" style="margin-bottom: 200px;">
                <div class="row">
                    <div class="col-md-2"></div>

                    <!-- كروت المستقلين -->
                    <div class="col-md-6 cards-container">
                        <FreelancerCard v-for="freelancer in sortedFreelancers" :key="freelancer.profiles_id"
                            :freelancer="freelancer" />
                    </div>

                    <!-- كارد الفلاتر -->
                    <div class="col-md-4 filter-container">
                        <div class="filter-card mb-2 p-2 rounded border shadow-lg">
                            <p class="me-2 mt-1" style="font-weight: bold; color: #296080;">فلترة النتائج:</p>
                            <div class="filters d-flex justify-content-between align-items-center mb-3">
                                <div class="filter me-2">
                                    <label for="regionFilter" class="form-label">المنطقة:</label>
                                    <select id="regionFilter" class="form-select form-select-sm" v-model="selectedCity">
                                        <option value="">كل المناطق</option>
                                        <option v-for="city in cities" :key="city.city_id" :value="city.city_id">
                                            {{ city.city_name }}
                                        </option>
                                    </select>
                                </div>

                                <div class="filter me-2">
                                    <label for="categoryFilter" class="form-label">الفئة:</label>
                                    <select id="categoryFilter" class="form-select form-select-sm"
                                        v-model="selectedCategory">
                                        <option value="">كل الفئات</option>
                                        <option v-for="category in categories" :key="category.categories_id"
                                            :value="category.categories_id">
                                            {{ category.categories_name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="rating-filter d-flex justify-content-between">
                                <button style="background-color: #296080;color: #fff; font-weight: bold;"
                                    class="btn me-2 btn-filter btn-hover" @click="sortOrder = 'desc'">
                                    الأعلى تقييمًا
                                    <i class="fa-solid fa-arrow-up" style="color: #f1995d;"></i>
                                </button>
                                <button style="background-color: #f1995d;color: #fff; font-weight: bold;"
                                    class="btn btn-filter btn-hover" @click="sortOrder = 'asc'">
                                    الأقل تقييمًا
                                    <i class="fa-solid fa-arrow-down" style="color: #296080;"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    </body>
</template>

<script>
import axios from "axios";
import Header from "../../components/header.vue";
import Footer from "../../components/footer.vue";
import FreelancerCard from "../../components/FreelancerCard.vue";

export default {
    name: "ProfessionPage",
    components: {
        Header,
        Footer,
        FreelancerCard,
    },
    data() {
        return {
            freelancers: [],
            categories: [],
            cities: [],
            isLoading: true,
            selectedCategory: "",
            selectedCity: "",
            sortOrder: "desc",
        };
    },
    watch: {
        selectedCategory() {
            this.sortedFreelancers;
        },
        selectedCity() {
            this.sortedFreelancers;
        }
    },
    mounted() {
        this.fetchFreelancers();
        this.fetchCategories();
        this.fetchCities();
    },
    methods: {
        async fetchFreelancers() {
            this.isLoading = true;
            try {
                const response = await axios.post(
                    "https://zadcodeonline.com/ahmad/etqan/backEnd/freelance/view.php",
                    {
                        limit: 10,
                        offset: 0,
                        userId: localStorage.getItem("userId")
                    },
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                this.freelancers = response.data.data;
            } catch (error) {
                console.error("Error fetching freelancers:", error);
            } finally {
                this.isLoading = false;
            }
        },
        async fetchCategories() {
            try {
                const response = await axios.post(
                    "https://zadcodeonline.com/ahmad/etqan/backEnd/categories/view.php"
                );
                this.categories = response.data.data;
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        },
        async fetchCities() {
            try {
                const response = await axios.post(
                    "https://zadcodeonline.com/ahmad/etqan/backEnd/city/view.php"
                );
                this.cities = response.data.data;
            } catch (error) {
                console.error("Error fetching cities:", error);
            }
        },
        filterFreelancers() {
            return this.freelancers.filter((freelancer) => {
                const categoryMatch =
                    !this.selectedCategory || Number(freelancer.category_id) === Number(this.selectedCategory);
                const cityMatch =
                    !this.selectedCity || Number(freelancer.city_id) === Number(this.selectedCity);
                return categoryMatch && cityMatch;
            });
        }
    },
    computed: {
        sortedFreelancers() {
            const filtered = this.filterFreelancers();
            return filtered.sort((a, b) => {
                return this.sortOrder === "asc"
                    ? a.freelance_rating - b.freelance_rating
                    : b.freelance_rating - a.freelance_rating;
            });
        },
    }
};
</script>

<style scoped>
/* التنسيقات العامة للصفحة */
@media (max-width: 768px) {
    .filter-container {
        order: -1;
    }

    .cards-container {
        order: 0;
    }
}

/* تأثير الفلاتر */
.filter-card {
    border-radius: 25px !important;
    background-color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-filter {
    border-radius: 25px;
    padding: 8px 20px;
    transition: background-color 0.3s ease;
}

.btn-hover:hover {
    background-color: #296080;
    color: white;
}

.filters select {
    border-radius: 8px;
    padding: 10px;
}

.filters label {
    font-weight: bold;
}

/* إضافة تحسينات على التباين */
body {
    background-color: #f5f5f5;
    padding-top: 55px;
}

footer {
    background-color: #296080;
    color: white;
    padding: 20px;
    text-align: center;
    border-top: 2px solid #fff;
}

@media (max-width: 768px) {
    body {
        padding-top: 15px;
    }

    .col-md-4 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .col-md-8 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .card {
        margin-bottom: 20px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
}
</style>